import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Tooltip } from 'reactstrap';

const MAX_TEXT_LENGTH = 24;

function TextWithToolTip({ text, idName, maxLength = MAX_TEXT_LENGTH, formatter = (str) => str }) {
   const [tooltipOpen, setTooltipOpen] = useState(false);
   const strText = text !== null ? formatter(text.toString()) : '';

   const toggle = () => {
      setTooltipOpen(!tooltipOpen);
   };

   return (
      <>
         {strText.length <= maxLength ? (
            strText
         ) : (
            <>
               <div id={idName}>{`${strText.substr(0, maxLength - 3)}...`}</div>
               <Tooltip placement='top' isOpen={tooltipOpen} target={idName} toggle={toggle}>
                  {strText}
               </Tooltip>
            </>
         )}
      </>
   );
}

TextWithToolTip.propTypes = {
   text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   idName: PropTypes.string,
   maxLength: PropTypes.number,
};

export default TextWithToolTip;
